export default __webpack_public_path__ + "static/media/host_naviHome_active.3e784910.svg";